import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, combineLatest } from 'rxjs';
import { TreeService } from '@schoolbelle/api/group-to-group';
import { GroupMemberService } from '@schoolbelle/api/group-member';
import { share } from 'rxjs/operators';
@Injectable()
export class AbstractLetterWriteResolve implements Resolve<any> {

  constructor(
    protected tree:TreeService,
    protected member:GroupMemberService,
  ) { }
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    return this.prepare();
  }
  prepare () {
    return combineLatest(
      this.tree.checkIn(),
      this.member.checkIn(),
      this.member.checkInMine(),
    ).pipe(
      share(),
    )

  }
}
